import * as Long from "long";
import { selectResourceInfo } from "../balancingSelectors/selectBalancingResources";
import { IdResource } from "../constants/IdResource";
import { IdMissingResourceTypes } from "../features/not-enough-resource/IdMissingResourceTypes";
import { utilNumber } from "../utils/utilNumber";
import { selectInventoryResourceInfo } from "./selectInventoryInfo";
export var selectNotEnoughResources = function (state) {
    var standardOngoingPurchase = state.ongoingPurchase
        .standard[0];
    var missingResources = standardOngoingPurchase.missingResources;
    var missingResourceInfo = missingResources.map(function (resource) {
        var availablePlayerResource = state.inventoryInfo.resource.find(function (item) { return item.typeId === resource.typeId; });
        return {
            available: availablePlayerResource ? availablePlayerResource.amount : Long.ZERO,
            missing: Long.fromValue(resource.amount),
            resource: selectResourceInfo(resource.typeId),
        };
    });
    if (missingResourceInfo.length === 1 &&
        missingResourceInfo[0].resource.id === IdResource.Money) {
        return {
            missingResources: missingResourceInfo,
            resourceType: IdMissingResourceTypes.Dollar,
        };
    }
    return {
        missingResources: missingResourceInfo,
        resourceType: standardOngoingPurchase.missingType,
    };
};
export var selectNotEnoughResourcesTotalGoldCost = function (missingQuantity, resourceGoldValue) {
    var totalGoldCostArray = utilNumber.multiplyWithRemainder(missingQuantity, resourceGoldValue);
    if (totalGoldCostArray[1].eq(Long.ZERO)) {
        return totalGoldCostArray[0];
    }
    // Adding ONE (1) to have a rounded GOLD amount instead of having floating GOLD amount which we cannot spend in fractions
    return totalGoldCostArray[0].add(Long.ONE);
};
export var selectNotEnoughResourcesMissingResources = function (state, resources) {
    return resources.reduce(function (missingResource, cost) {
        var playerResource = selectInventoryResourceInfo(state, cost.typeId);
        if (playerResource.amount.lessThan(Long.fromValue(cost.amount || Long.ZERO))) {
            var missingResourceInfo = {
                amount: Long.fromValue(cost.amount).subtract(playerResource.amount),
                typeId: cost.typeId,
            };
            missingResource.push(missingResourceInfo);
        }
        return missingResource;
    }, []);
};
export var selectNotEnoughResourceTotalGoldCost = function (notEnoughResourceInfo) {
    var items = notEnoughResourceInfo.missingResources;
    return items.reduce(function (totalCost, cost) {
        if (!cost.resource || !cost.resource.goldValue || !cost.missing) {
            return totalCost;
        }
        var totalMissingItems = cost.missing;
        var resourceGoldValue = cost.resource.goldValue.amount;
        var totalGoldCost = selectNotEnoughResourcesTotalGoldCost(totalMissingItems, resourceGoldValue);
        return Long.fromValue(totalCost).add(totalGoldCost);
    }, Long.ZERO);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectNotEnoughResources.ts
// module id = 149
// module chunks = 3